import React from 'react';
import { shortQuotes } from '../data/content';
export function TestimonialsStrip() {
  return <section aria-label="What directors say" className="border-b border-line bg-night py-14 sm:py-16" data-id="element-269" data-mp="3e1xjnb5uwkqw">
      <ul className="mx-auto grid max-w-7xl gap-8 px-5 sm:px-8 lg:grid-cols-3" data-id="element-270" data-mp="3srd7aia3ca2d">
        {shortQuotes.map(item => <li key={item.name} className="flex flex-col border-t border-acid pt-5" data-id="element-271" data-mp="3ny0jubh5e9b7">
            <blockquote className="text-sm leading-relaxed text-white/70 sm:text-base" data-id="element-272" data-mp="5kauxcl9kgzq">
              &ldquo;{item.quote}&rdquo;
            </blockquote>
            <p className="mt-auto pt-4 text-[11px] font-semibold uppercase tracking-[0.16em] text-white/40" data-id="element-273" data-mp="fjs3c1rwh8ze">
              {item.name} · {item.role}
            </p>
          </li>)}
      </ul>
    </section>;
}